import React from 'react';
import {render} from 'react-dom';
import native from 'c-up-native';
import visitor from '../visitor';
import Profile from '../profile';
import SM from '../sm';
import {giftService} from '../../config';
import ProjectListPb from '../../pb/giftitemlist.pb';

SM.init();

// window.addEventListener('message', function (e) {
//     console.log(e);
// });
const getProjectList = giftService('/gift/item/list', ProjectListPb.Gift.ItemList);

function registerVistor(cb) {
    visitor.register().then(data => {
        UG.cache.setCache('user', {
            uid: longToString(data.uid),
            userToken: data.userToken,
            subscribe: data.subscribe,
            isVisitor: true
        });
        //  在GIFTO里面需要判断是不是登录状态的
        cb();
    });
}

function bindIm() {
    if (window.imBound) {
        return;
    }
    // 注释不可省略，否则不能显示文件名称
    System.import(/* webpackChunkName: "im-common-module" */'../../im/common').then(module => {
        const notice = function () {
            $.channel.emit('newMessageReceive');
        };
        window.imcommon = module.default;
        window.imcommon.im.on('message', notice);
        window.imBound = true;
        setTimeout(notice, 1000);
    }).catch(err => {
        console.log(err);
    });
}

function loginInit(App, NoPermission) {
    const goHome = () => {
        getProjectList({pageSize: 1, pageNum: 1, itemType: 2})
            .then(({itemInfos, totalItem}) => {
                if (itemInfos && itemInfos.length > 0) {
                    UG.router.replace('/');
                } else {
                    UG.router.replace('/createitem/1');
                }
            })
            .catch(() => {
                UG.router.replace('/createitem/1');
            });
    };
    // 获取数美deviceid是应用初始化的前置条件
    SM.getSMDeviceId().done(() => {
        let appMain = (msg) => {
            // UG.getLoginUserProfile((msg) => {
            // 获取当前用户成功回调
            UG.loginUserInfo = msg;

            if (!UG.isVistor()) {
                // 绑定IM
                bindIm();

                let beforeLoginHash = UG.cache.getCache('beforeLoginHash');

                // 除了送礼页面过来的，其他的全部跳转到项目列表页面
                if (beforeLoginHash) {

                    // 先删除在说吧
                    UG.cache.removeCache('beforeLoginHash');

                    if (beforeLoginHash === '#/gift') {
                        location.hash = beforeLoginHash;
                    } else {
                        // 检查一下用户有没有创建项目
                        goHome();
                    }
                } else if (location.hash === '#/login') {
                    // 检查一下用户有没有创建项目
                    goHome();
                }
            }

            if (UG.isUplive) {
                if (['HK', 'TW', 'WF', 'KR'].indexOf(msg.countryCode) !== -1) {
                    render(<App/>, $('#wrap')[0]);
                } else {
                    render(<NoPermission/>, $('#wrap')[0]);
                }
            } else {
                render(<App/>, $('#wrap')[0]);
            }
        };
        //  如果是Uplive，直接通过协议取userToken等信息
        if (UG.isUplive) {
            return native.getConfigs({
                complete: (data) => {
                    UG.cache.setCache('user', {
                        uid: data.uid,
                        subscribe: 0,
                        userToken: data.usertoken,
                        isVisitor: false
                    }, 8 * 3600 * 1000);
                    // 开始获取数据，并开始渲染页面了
                    Profile.getUserInfoByIdAndToken(data.uid, data.usertoken)
                        .then(appMain)
                        .catch(err => console.log(err));
                }
            });
        } else {
            // 这些页面是访客可以访问的
            const isLoginUrl = location.hash === '#/login';
            const isAllowUrl = /\/(profile|gift|land|giftshow)\/?/.test(location.hash);
            const isVistor = UG.isVistor();
            // todo
            Profile.isValidUser(UG.getUser())
                .then(userInfo => {
                    // 成功获取到了信息
                    if (userInfo) {
                        if (isVistor && isAllowUrl) {
                            render(<App/>, $('#wrap')[0]);
                        } else if (isVistor) {
                            UG.router.push('/login');
                            render(<App/>, $('#wrap')[0]);
                        } else {
                            if (isLoginUrl) {
                                UG.router.replace('/');
                            }
                            appMain(userInfo);
                        }
                    } else {
                        // 没有登录
                        // 先注册一个访客，保证接口是可以访问的
                        registerVistor(function () {
                            //  在GIFTO里面需要判断是不是登录状态的
                            if (isAllowUrl) {
                                render(<App/>, $('#wrap')[0]);
                            } else {
                                if (!isLoginUrl) {
                                    UG.router.push('/login');
                                }
                                render(<App/>, $('#wrap')[0]);
                            }
                        });
                    }
                });
        }

        UpSDK.on('getUserSuccess', function (data) {
            // 有isVisitor说明是取到的系统的缓存
            console.log('授权成功了', data);
            UG.cache.setCache('user', {
                uid: data.uid,
                userToken: data.userToken,
                subscribe: data.subscribe,
                isVisitor: false
            });
            // 加载数据并渲染页面
            Profile.getUserInfoByIdAndToken(data.uid, data.userToken).then(appMain);
        });

        window.onpageshow = function (event) {
            if (event.persisted) {
                window.location.reload();
            }
        };
    });
}

function isLogined() {
    return !UG.isVistor() || UG.isUplive;
}

export {loginInit, isLogined};



// WEBPACK FOOTER //
// ./js/component/login/index.js